import { ReloadOutlined } from '@ant-design/icons'
import { Form, Tooltip } from 'antd'
import { t } from 'i18next'
import React from 'react'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import CtxFormulaSelect from '../../../../../../../features/formulas/components/CtxFormulaSelect'
import { RowType } from '../../../../../../../redux/context/customReports/typesVariable'
import { useCtxFormulas } from '../../../../../../../features/formulas/queries/useCtxFormulas'

const FormulaId = () => {
  const form = useFormInstance()
  const { data: formulas = [] } = useCtxFormulas()
  const formulaId = Form.useWatch('formulaId', form)

  const updateTranslations = (id?: number) => {
    const formula = formulas.find(f => f.id === id)
    formula &&
      form.setFieldsValue({
        nameFi: formula.nameFi,
        nameEn: formula.nameEn,
        nameSv: formula.nameSv
      })
  }

  return (
    <Form.Item
      key={RowType.formula}
      name="formulaId"
      rules={[{ required: true, message: t('global:required-field') }]}
      label={
        <div>
          {t('global:formula')}
          <Tooltip title={t('customReportPage:updateFormulaTranslations')}>
            <ReloadOutlined
              style={{ marginLeft: 5, color: '#0225a1', fontSize: 14 }}
              onClick={() => {
                updateTranslations(formulaId)
              }}
            />
          </Tooltip>
        </div>
      }
    >
      <CtxFormulaSelect />
    </Form.Item>
  )
}

export default FormulaId
